import React from "react";

import Header from "../Components/Header";
import About from "../Components/About";
import Portfolio from "../Components/Portfolio";
import Resume from "../Components/Resume";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";

const Home = ({ resumeData }) => {
  return (
    <div className="App">
      <Header data={resumeData.main} />
      <Portfolio data={resumeData.portfolio} />
      <Resume data={resumeData.resume} />
      <About data={resumeData.main} />
      <Contact data={resumeData.main} />
      <Footer data={resumeData.main} />
    </div>
  );
};

export default Home;

